import React from 'react';
import FullscreenAdminShell from './FullscreenAdminShell';
import ReviewerClientOnly from './ReviewerClientOnly';
import { loadData } from '../AdminSocialPostsPage/AdminSocialPostsPage.duck';

/**
 * AdminSocialReviewerPage — the full-screen, chrome-less reviewer the social
 * manager opens from the notification email (route /admin-social/review?post=ID).
 *
 * It reuses the AdminSocialPostsPage duck wholesale (same store slice, same
 * optimistic helpers) — the reviewer is a richer VIEW over the existing data,
 * not a parallel feature. Admin gating + currentUser/history injection come from
 * the shared FullscreenAdminShell (adminPageHOC), which — unlike the dashboard's
 * AdminPageHolder — omits the marketplace Topbar/Footer so the reviewer is a true
 * full-screen takeover (the same shell the Workflow Studio mounts through).
 *
 * The animated, DOM-reaching subtree (Motion layout + the design editor) lives
 * behind ReviewerClientOnly (mount-guard + React.lazy + error boundary) so it
 * never runs during SSR.
 */
const AdminSocialReviewerPage = () => (
    <FullscreenAdminShell
        title="AdminSocialReviewerPage"
        schema={{
            '@context': 'http://schema.org',
            '@type': 'AdminSocialReviewerPage',
            description: 'Social media reviewer',
            name: 'Admin panel',
        }}
    >
        <ReviewerClientOnly />
    </FullscreenAdminShell>
);

// Reuse the dashboard loadData: it reads ?post= and fetches the pending list +
// the deep-linked post (client-only, admin-cookie authenticated).
AdminSocialReviewerPage.loadData = loadData;

export default AdminSocialReviewerPage;
